import React, { useState } from "react"
import { shape, number, oneOf, func } from "prop-types"
import useApiAction from "hooks/use_api_action"
import pendoTrackEvent from "utils/pendo_track_event"

export default function ToggleQuestionTypeButton({
  signup,
  question,
  group,
  onQuestionTypeToggle
}) {
  const [disabled, setDisabled] = useState(false)
  const toggleQuestion = useApiAction({
    path: `events/${signup.id}/questions/${question.id}/toggle_type`
  })
  const convertingQuestionType =
    group == "attendee" ? "Attendee Form Question" : "Attendee Question"
  const buttonText = `Convert to ${convertingQuestionType}`

  return (
    <button
      onClick={() => {
        setDisabled(true)
        pendoTrackEvent(`Question converted to ${convertingQuestionType}`)
        toggleQuestion.run().then(resp => onQuestionTypeToggle(resp.data))
      }}
      className="staff-only btn2 sm-btn"
      disabled={disabled}
    >
      {buttonText}
    </button>
  )
}

ToggleQuestionTypeButton.propTypes = {
  signup: shape({ id: number.isRequired }).isRequired,
  question: shape({ id: number.isRequired }).isRequired,
  group: oneOf(["attendee", "attendee_form"]).isRequired,
  onQuestionTypeToggle: func.isRequired
}
